<div [ngClass]="cssMediaService.deviceCss('slider')">
    <input
        [(ngModel)]="value"
        [max]="max"
        [min]="min"
        [ngClass]="cssMediaService.deviceCss('range')"
        [step]="step"
        type="range"
    />
    <div [ngClass]="cssMediaService.deviceCss('text')">
        <div class="inner">
            <label>{{ title }}</label>
        </div>
    </div>
</div>
